<template>
    <div>
        <div class="alert alert-success" v-if="showAlarm">
            <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
            <span>
                <b>{{ alarm }}</b>
            </span>
        </div>
        <div class="alert alert-danger" v-if="tempAlert" id="MessWarning">
            <button type="button" aria-hidden="true" class="close" v-on:click="disableTempNotification">×</button>
            <span class="messstellenWarnung">
                <b>
                    <h3>
                        <v-icon left large>warning</v-icon>
                        Folgende Messstellen wurden nicht überprüft:<br />
                    </h3>

                    <div v-if="missingBereiche1">Bereich 1: {{ missingBereiche1 }}<br /></div>
                    <div v-if="missingBereiche2">Bereich 2: {{ missingBereiche2 }}<br /></div>
                    <div v-if="missingBereiche3">Bereich 3: {{ missingBereiche3 }}<br /></div>
                    <div v-if="missingBereiche4">Bereich 4: {{ missingBereiche4 }}<br /></div>
                </b>
            </span>
        </div>

        <card :title="title" id="frame">
            <!-- <h2 class="page-header">Bestellungen</h2>       -->

            <div class="datediv">
                <div class="float left">
                    <label for="date">Datum:</label><br />
                    <input type="date" id="date" v-model="datum" />
                </div>
                <div class="float-right button">
                    <v-btn color="grey" v-on:click="fetchBestellungenDatum">anzeigen</v-btn>
                </div>
            </div>
            <div>
                <div class="float-right button">
                    <v-btn color="grey" v-on:click="pushPackliste"><v-icon class="buttonicon" color="white">insert_drive_file</v-icon> Packliste</v-btn>
                    <v-btn color="grey" v-on:click="pushMap"><v-icon class="buttonicon" color="white">place</v-icon>Map</v-btn>
                </div>
            </div>
        </card>

        <div v-if="bestellungen.length == 0" class="keinebestellungen">Keine Bestellungen für diesen Tag vorhanden</div>
        <div v-for="bestellung in bestellungen" v-bind:key="bestellung.Bestellnummer">
            <div v-if="bestellung.fahrer == fahrerValue || allowedForDashboard || büro" class="card" :style="{ backgroundColor: bestellung.Farbe }" id="termine">
                <div class="card-header" id="header">
                    <h5 class="card-title" id="title">
                        <div v-if="bestellung.Kundennummer !== '1'">
                            <span v-if="bestellung.Firma.length >= 2">{{ bestellung.Firma }}</span>
                            <span v-else>{{ bestellung.Nachname }}</span>
                        </div>
                        <div v-else>
                            <span>{{ bestellung.Bestellbemerkung }}</span>
                        </div>

                        <div v-if="bestellung.Kundennummer !== '1'" class="shopicons">
                            <v-icon v-if="bestellung.Selbsteinkaeufer == 1 && !(bestellung.Firma.length >= 2)">shopping_basket</v-icon>
                            <v-icon v-else-if="bestellung.Selbsteinkaeufer == 0 && !(bestellung.Firma.length >= 2)">shopping_cart</v-icon>
                            <v-icon v-if="bestellung.Firma.length >= 2">store</v-icon>
                            <v-icon v-if="bestellung.ReihenterminId">list</v-icon>
                            <v-chip v-if="allowedForDashboard || büro" class="ma-2" color="grey" text-color="white" right>Fahrer {{ bestellung.fahrer }}</v-chip>
                        </div>
                    </h5>
                    <p class="card-category tablecard" id="subtitle">{{ bestellung.Uhrzeit }}</p>
                    <div class="functions" v-if="bestellung.Kundennummer !== '1'">
                        <v-btn flat icon large color="white" id="graphbutton" v-on:click="gotoDetails(bestellung.Bestellnummer)" right>
                            <v-icon>info</v-icon>
                        </v-btn>
                        <v-btn v-if="bestellung.stat == 0" flat large icon color="white" id="graphbutton" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.stat)">
                            <v-icon>check_circle</v-icon>
                        </v-btn>
                        <v-btn v-if="bestellung.stat == 1" flat large icon color="white" id="graphbutton" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.stat)">
                            <v-icon>radio_button_unchecked</v-icon>
                        </v-btn>
                        <v-btn v-if="allowedForDashboard || büro" flat icon large color="white" id="graphbutton" v-on:click="pushEdit(bestellung.Bestellnummer)" left>
                            <v-icon>edit</v-icon>
                        </v-btn>
                    </div>
                    <div id="graphbuttonblocker" v-else>
                        <v-btn v-if="(allowedForDashboard || büro) && !deleteBlockerMessage && !deleteBlockerRowMessage" flat icon large color="white"  v-on:click="deleteBlockerMessage = true" left>
                            <v-icon color="white">delete</v-icon>
                        </v-btn>
                        <span style="color:white"  v-if="deleteBlockerMessage">
                            Termin löschen. Sind sie sicher? 
                        <v-btn  flat icon large color="white"  left v-on:click="deleteBlockerMessage = false">
                            <v-icon color="red">close</v-icon>
                        </v-btn>
                         <v-btn  flat icon large color="white"  left v-on:click="deleteBlocker(bestellung.Bestellnummer)">
                            <v-icon color="green">check</v-icon>
                        </v-btn>
                        </span>
                        <v-btn v-if="((allowedForDashboard && bestellung.ReihenterminId) || (büro && bestellung.ReihenterminId))&& !deleteBlockerRowMessage &&!deleteBlockerMessage" flat icon large color="white"  v-on:click="deleteBlockerRowMessage = true" left>
                            <v-icon color="white">delete_sweep</v-icon>
                        </v-btn>
                       
                         <span  v-if="deleteBlockerRowMessage" style="color:white" >
                            Reihentermin löschen. Sind sie sicher? 
                        <v-btn  flat icon large color="white"  left v-on:click="deleteBlockerRowMessage = false">
                            <v-icon color="red">close</v-icon>
                        </v-btn>
                        <v-btn  flat icon large color="white"  left v-on:click="deleteReihentermin(bestellung.ReihenterminId)">
                            <v-icon color="green">check</v-icon>
                        </v-btn>
                        </span>
                        <!-- <v-btn flat icon large color="white" id="graphbutton" v-on:click="deleteBlocker(bestellung.Bestellnummer)" v-on="on" right>
                            <v-icon>delete</v-icon>
                        </v-btn> -->
                        <!-- <v-dialog v-if="allowedForDashboard || büro" v-model="dialog" width="500">
                            <template v-slot:activator="{ on }">
                                <v-btn flat icon large color="white" id="graphbutton" v-on="on" right>
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </template>

                            <v-card>
                                <v-card-title class="headline grey lighten-2" primary-title> Blocker bearbeiten </v-card-title>

                                <v-list>
                                    <v-list-tile v-if="allowedForDashboard || büro" @click="deleteBlocker(bestellung.Bestellnummer)">
                                        <v-list-tile-action>
                                            <v-icon color="red">delete</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Termin löschen</v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>

                                    <v-list-tile
                                        v-if="(allowedForDashboard && bestellung.ReihenterminId) || (büro && bestellung.ReihenterminId)"
                                        @click="deleteReihentermin(bestellung.ReihenterminId)">
                                        <v-list-tile-action>
                                            <v-icon color="red">delete_sweep</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Reihentermin löschen</v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </v-list>
                            </v-card>
                        </v-dialog> -->
                        <!-- dialog end -->
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="card border-dark mb-3 text-center" v-for="bestellung in bestellungen"> 
              <span :class="{bestellungDone: bestellung.stat == 0}">
							<div class="card-header">
                
								<h5>
                  <span class="float-left">
                    {{bestellung.Nachname}}<br>{{bestellung.Firma}}
                  </span>
                  <span class="float-none">
                  
                    <button v-if="bestellung.stat == 1" class="btn btn-light btn-sm" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.stat)"><i class="material-icons">visibility_off</i></button>
                    <button v-if="bestellung.stat == 0" class="btn btn-light btn-sm" v-on:click="changeStatus(bestellung.Bestellnummer, bestellung.stat)"><i class="material-icons">visibility</i></button>
                  </span>
                  <span class="float-right">
                    K.-Nr.: {{bestellung.Kundennummer}}
                  </span>
                </h5><br>
                <span class="float-left">
								<b>
								{{bestellung.Datum}} {{bestellung.Uhrzeit}} Uhr
                </b>
                </span>
                <span class="float-right">
                  <div>
                    <v-btn large color="orange" v-on:click="showDate(bestellung.Bestellnummer)">Informationen</v-btn>
                  </div>

                </span>
							</div>
              </span>
						</div> -->
    </div>
</template>

<script>
import firebase from "firebase"
export default {
    name: "BestellungenDatum",
    data() {
        return {
            deleteBlockerMessage: false,
            deleteBlockerRowMessage: false,
            dialog: false,
            auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
            bestellungen: [],
            kunde: [],
            datum: "",
            title: "Bestellungen",
            alarm: "",
            showAlarm: false,
            allowedForDashboard: false,
            isLoggedIn: false,
            // uhl: false,
            fahrer1: false,
            fahrer2: false,
            büro: false,
            uhlmail: "t.uhl@rewe-uhl.de",
            fahrermails: ["fahrer1@heimspiel.de", "fahrer2@heimspiel.de"],
            büromail: "buero@heimspiel.de",
            fahrerValue: 0,
            missingBereiche1: "",
            missingBereiche2: "",
            missingBereiche3: "",
            missingBereiche4: "",
            tempAlert: false,
            colors: [
                `rgb(173, 159, 75)`,
                `rgb(36, 182, 220)`,
                `rgb(82, 37, 145)`,
                `rgb(82, 159, 145)`,
                `rgb(173, 159, 145)`,
                `rgb(27, 42, 224)`,
                `rgb(173, 92, 75)`,
                `rgb(27, 98, 18)`,
                `rgb(192, 98, 18)`,
                `rgb(198, 38, 51)`
            ],
            blockerColor: `rgb(0,0,0)`
        }
    },
    methods: {
        deleteReihentermin(id) {
            this.dialog = false
            this.$http.post(process.env.VUE_APP_NODE_API_URL + "/heimspiel/deleteRow/" + id, {}, { headers: { Authorization: this.auth } }).then(function(response) {
                console.log(response)
                this.terminArray = response.body.data
                var i = 0
                // this.deleteRowTermin(i, this.terminArray);

                setTimeout(() => {
                    this.$router.push({
                        path: "/kunden",
                        query: { alarm: "Reihentermine gelöscht!" }
                    })
                }, 1000)
            })

            //
        },
        deleteBlocker(bestellnummer) {
            this.$http.post(process.env.VUE_APP_PHP_API_URL + "/bestellung/delete/" + bestellnummer, { auth: process.env.VUE_APP_PHP_AUTH }).then(function(response) {
                // this.deleteTermin(this.bestellung.id, this.bestellung.kalender)
                console.log(response)
                this.$router.push({
                    path: "/kunden",
                    query: { alarm: "Blocker gelöscht!" }
                })
            })
        },
        pushMap() {
            this.$router.push({ path: "/googlemap" })
        },
        pushEdit(id) {
            this.$router.push({ path: "/editbestellung/" + id })
        },
        pushPackliste() {
            this.$router.push({ path: "/packliste" })
        },
        gotoDetails(id) {
            console.log(id)
            this.$router.push({ path: "/bestellung/" + id })
        },
        // randomColor(id) {
        //   const r = () => Math.floor(200 * Math.random());
        //   return `rgb(${r()}, ${r()}, ${r()})`;
        // },
        createToday() {
            var today = new Date()
            var dd = String(today.getDate()).padStart(2, "0")
            var mm = String(today.getMonth() + 1).padStart(2, "0") //January is 0!
            var yyyy = today.getFullYear()

            var date = yyyy + "-" + mm + "-" + dd
            return date
        },
        showDate(bestellnummer) {
            this.$router.push("/bestellung/" + bestellnummer)
        },
        disableNotification() {
            this.showAlarm = !this.showAlarm
        },
        disableTempNotification() {
            if (confirm("Wurde eine Überprüfung veranlasst?")) {
                this.tempAlert = false
            }
        },
        fetchBestellungen() {
            var date = this.createToday()
            console.log(date)
            this.$http.post(process.env.VUE_APP_PHP_API_URL + "/bestellungen/" + date, { auth: process.env.VUE_APP_PHP_AUTH }).then(function(response) {
                var color = 0
                for (var i = 0; i < response.body.length; i++) {
                    console.log(response.body)
                    if (color == 10) {
                        color = 0
                    }

                    response.body[i].Uhrzeit = response.body[i].Uhrzeit.substring(0, 5) + " Uhr"
                    this.bestellungen.push(response.body[i])
                    this.bestellungen[i].Farbe = this.colors[color]
                    if (response.body[i].Kundennummer == "1") {
                        this.bestellungen[i].Farbe = this.blockerColor
                    }
                    color++
                }
            })
        },
        fetchBestellungenDatum() {
            this.bestellungen.push(1)
            this.bestellungen.length = 0
            this.$http.post(process.env.VUE_APP_PHP_API_URL + "/bestellungen/" + this.datum, { auth: process.env.VUE_APP_PHP_AUTH }).then(function(response) {
                var color = 0
                for (var i = 0; i < response.body.length; i++) {
                    if (color == 10) {
                        color = 0
                    }
                    response.body[i].Uhrzeit = response.body[i].Uhrzeit.substring(0, 5) + " Uhr"
                    this.bestellungen.push(response.body[i])
                    this.bestellungen[i].Farbe = this.colors[color]
                    if (response.body[i].Kundennummer == "1") {
                        this.bestellungen[i].Farbe = this.blockerColor
                    }
                    color++
                }
            })
        },
        fetchMissingMessstellen() {
            this.$http.get(process.env.VUE_APP_NODE_API_URL + "/heimspiel/tempLogs/check", { headers: { Authorization: this.auth } }).then(function(response) {
                if (response.body.missingBereiche1 || response.body.missingBereiche2 || response.body.missingBereiche3 || response.body.missingBereiche4) {
                    this.missingBereiche1 = response.body.missingBereiche1
                    this.missingBereiche2 = response.body.missingBereiche2
                    this.missingBereiche3 = response.body.missingBereiche3
                    this.missingBereiche4 = response.body.missingBereiche4
                    this.tempAlert = true
                }
            })
        },
        gotoMaps(Strasse, Hausnummer, PLZ, Stadt) {
            window.location.href = "https://www.google.com/maps/dir/?api=1&destination=" + Strasse + "+" + Hausnummer + "+" + PLZ + "+" + Stadt + "+Germany&travelmode=driving"
        },
        changeStatus(bestellnr, stat) {
            var results = []
            if (stat == 0) {
                stat = 1
                for (var i = 0; i < this.bestellungen.length; i++) {
                    if (this.bestellungen[i].Bestellnummer == bestellnr) {
                        this.bestellungen[i].stat = stat
                    }
                }
            } else {
                stat = 0
                for (var i = 0; i < this.bestellungen.length; i++) {
                    if (this.bestellungen[i].Bestellnummer == bestellnr) {
                        this.bestellungen[i].stat = stat
                    }
                }
            }
            let updatedStatus = {
                stat: stat,
                auth: process.env.VUE_APP_PHP_AUTH
            }
            this.$http.put(process.env.VUE_APP_PHP_API_URL + "/bestellung/status/" + bestellnr, updatedStatus).then(function(response) {})
        }
        // deleteTermin(id){
        //       this.$http.delete('https://api.uhl.katsios-kesting.de/bestellung/delete/'+ id)
        //       .then(function(response){
        //           this.$router.push({path: '/bestellungen/' + this.datum, query: {alarm: 'Bestellung gelöscht!'}});
        //   });
        // }
    },
    // watch: {
    //   rerender: {
    //     handler: function() {
    //       // Neuladen der Chart

    //     },
    //     deep: true
    //   }
    // },
    created: function() {
        if (this.$route.query.date) {
            this.datum = this.$route.query.date
            this.fetchBestellungenDatum()
        } else {
            this.datum = this.createToday()
            this.fetchBestellungen()
        }
        if (this.$route.query.alarm) {
            this.alarm = this.$route.query.alarm
            this.showAlarm = true
        }

        if (firebase.auth().currentUser) {
            this.isLoggedIn = true
            var mail = firebase.auth().currentUser.email
            if (mail === this.uhlmail) {
                this.allowedForDashboard = true
            } else if (mail === this.büromail) {
                this.büro = true
            } else if (mail === this.fahrermails[0]) {
                this.fahrer1 = true
                this.fahrerValue = 1
            } else if (mail === this.fahrermails[1]) {
                this.fahrer2 = true
                this.fahrerValue = 2
            }
        }
        var actualHour = new Date().getHours()
        if (14 < actualHour) {
            this.fetchMissingMessstellen()
        }
    },
    updated: function() {
        // this.fetchBestellungen();
    },
    components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only | durchgestrichen: text-decoration: line-through; -->
<style scoped>
#MessWarning {
    background-color: rgb(209, 32, 8);
}
.keinebestellungen {
    padding-top: 50px;
    text-align: center;
}
.alert {
    border-radius: 7px 7px 7px 7px;
    text-align: center;
}
.bestellungDone {
    -webkit-opacity: 0.25;
    -khtml-opacity: 0.25;
    -moz-opacity: 0.25;
    opacity: 0.25;
    color: rgba(0, 0, 0, 0.25);
}
#frame {
    margin-left: 0%;
}
.datediv {
    padding-left: 10px;
    padding-top: 10px;
    padding-right: 0%;
    display: block;
}
#date {
    margin-bottom: 10px;
    padding: 5px;
    border: 2px solid rgb(117, 108, 108);
    border-radius: 5px;
}
.button {
    padding-top: 21px;
    padding-right: 0%;
}
#termine {
    margin-bottom: 8px;
}
#graphbutton {
    margin-top: 0%;
    margin-top: 0%;
    float: right;
}
#graphbuttonblocker {
    margin-top: 0%;
    margin-top: 0%;
    float: right;
    padding-right: 30px;
}
#title {
    color: white;
    font-weight: bold;
}
#subtitle {
    color: white;
    font-weight: bold;
}
#header {
    padding-right: 0px;
    padding-bottom: 12px;
}
.buttonicon {
    padding-right: 5px;
}
.shopicons {
    display: inline;
    padding-left: 10px;
}
.nummer {
    display: inline;
    padding-right: 10px;
}
.messstellenWarnung {
    color: white;
}
</style>
